import { valueConverter } from "aurelia-binding";

@valueConverter("objectKeys")
export class ObjectKeys {
    public toView(obj: object) {
        return obj ? Object.keys(obj) : [];
    }
}